
jQuery('body').on('click','.save-design-os', function(e){
  e.preventDefault(); 
  if(jQuery('.kb-locker-room-buttons button:not(.ng-hide)').hasClass('kb-locker-room-buttons-login')){
    var shareLink = window.createKbShareLink && window.createKbShareLink(false);
      hbspt.forms.create({
        region: "na1",
        portalId: "2685007",
        formId: "488fd4e1-6140-40d7-b942-763df2fac2e1",
        target: ".share-hbs-form-container",
        onFormSubmit: function($form) {
          console.log(shareLink);
          $form.find('[name="share_design"]').val(shareLink);
        }
      });
    jQuery('.share-link-pop').addClass('active');
      jQuery('#sharelink-os').val(shareLink);
  }else{    
    if(jQuery('.kb-locker-room-buttons button:not(.ng-hide)').hasClass('kb-locker-room-buttons-save-update')){
      jQuery('.kb-locker-room-buttons button.kb-locker-room-buttons-save-update:not(.ng-hide)').click();
      jQuery(this).addClass('waiting');
      var shareLink = window.createKbShareLink && window.createKbShareLink(false);
      hbspt.forms.create({
        region: "na1",
        portalId: "2685007",
        formId: "488fd4e1-6140-40d7-b942-763df2fac2e1",
        target: ".share-hbs-form-container",
        onFormSubmit: function($form) {
          console.log(shareLink);
          $form.find('[name="share_design"]').val(shareLink);
        }
      });
      jQuery('#sharelink-os').val(shareLink);
      var interval = setInterval(function(){
        if(jQuery('.kb-customize-container .kb-notifications').find('.kb-alert-success').length>0){
          clearInterval(interval);

          jQuery('.share-link-pop').addClass('active');
          jQuery('.save-design-os').removeClass('waiting');
        }
      },250)
    }else if(jQuery('.kb-locker-room-buttons button:not(.ng-hide)').hasClass('kb-locker-room-buttons-save-new')){
      jQuery('.kb-locker-room-buttons button.kb-locker-room-buttons-save-new:not(.ng-hide)').click();
      var shareLink = window.createKbShareLink && window.createKbShareLink(false);
      hbspt.forms.create({
        region: "na1",
        portalId: "2685007",
        formId: "488fd4e1-6140-40d7-b942-763df2fac2e1",
        target: ".share-hbs-form-container",
        onFormSubmit: function($form) {
          console.log(shareLink);
          $form.find('[name="share_design"]').val(shareLink);
        }
      });
      jQuery('#sharelink-os').val(shareLink);
      var interval = setInterval(function(){
        if(jQuery('.kb-customize-container .kb-notifications').find('.kb-alert-success').length>0){
          clearInterval(interval);
          jQuery('.share-link-pop').addClass('active');
        }
      },250)
    }else{
      jQuery('.kb-locker-room-buttons button:not(.ng-hide)').click();
    }
  }
})
jQuery('.share-link-pop .copy-close').click(function(){
  jQuery('#sharelink-os').select();
  document.execCommand("copy");
  jQuery('.share-link-pop').removeClass('active');
  jQuery('.share-link-content .hbspt-form').remove()
})
jQuery('.share-link-pop .pop-close').click(function(){  
  jQuery('.share-link-pop').removeClass('active');
  jQuery('.share-link-content .hbspt-form').remove()
})